module.exports = __webpack_public_path__ + "assets/img/tab2_02.3d14ae9d.jpg";